import { c as read_implementation, b as base, m as manifest } from "./server.js";
import { a as b64_decode } from "./utils.js";
function read(asset) {
  ;
  if (!read_implementation) {
    throw new Error(
      "No `read` implementation was provided. Please ensure that your adapter is up to date and supports this feature"
    );
  }
  const match = /^data:([^;,]+)?(;base64)?,/.exec(asset);
  if (match) {
    const type = match[1] ?? "application/octet-stream";
    const data = asset.slice(match[0].length);
    if (match[2] !== void 0) {
      const decoded2 = b64_decode(data);
      return new Response(decoded2, {
        headers: {
          "Content-Length": decoded2.byteLength.toString(),
          "Content-Type": type
        }
      });
    }
    const decoded = decodeURIComponent(data);
    return new Response(decoded, {
      headers: {
        "Content-Length": decoded.length.toString(),
        "Content-Type": type
      }
    });
  }
  const file = decodeURIComponent(
    asset.slice(base.length + 1)
  );
  if (file in manifest._.server_assets) {
    const length = manifest._.server_assets[file];
    const type = manifest.mimeTypes[file.slice(file.lastIndexOf("."))];
    return new Response(read_implementation(file), {
      headers: {
        "Content-Length": "" + length,
        "Content-Type": type
      }
    });
  }
  throw new Error(`Asset does not exist: ${file}`);
}
export {
  read as r
};
